module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "btn-group pull-right",
    attrs: {
      "role": "group",
      "aria-label": ""
    }
  }, [(!_vm.loading && _vm.success) ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickCreateNew
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-circle"
  }), _vm._v(" Create\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickGuide
    }
  }, [_c('i', {
    staticClass: "fas fa-question"
  }), _vm._v(" Guide\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickDashboards
    }
  }, [_c('i', {
    staticClass: "fas fa-tachometer-alt"
  }), _vm._v(" Dashboards\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickRefresh
    }
  }, [_c('i', {
    staticClass: "fas fa-sync"
  }), _vm._v(" Refresh\n      ")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [(_vm.showFeedback) ? _c('feedback', {
    attrs: {
      "message": _vm.feedbackMessage,
      "spin": _vm.showSpinner,
      "success": _vm.success
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.success && _vm.rows.length > 0) ? _c('div', [_c('vue-good-table', {
    attrs: {
      "title": "Helium Journey Apps",
      "columns": _vm.columns,
      "rows": _vm.rows,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'appName',
          type: 'asc'
        }
      },
      "search-options": {
        enabled: true
      },
      "paginationOptions": {
        enabled: true
      },
      "styleClass": "vgt-table striped bordered table-hover",
      "lineNumbers": true
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'status') ? _c('span', [(props.row.status === 'Enabled') ? _c('div', [_c('span', {
          staticClass: "badge badge-success"
        }, [_c('i', {
          staticClass: "fa fa-play",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n                      " + _vm._s(props.row.status) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (props.row.status === 'Disabled') ? _c('div', [_c('span', {
          staticClass: "badge badge-warning"
        }, [_c('i', {
          staticClass: "fa fa-stop",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n                      " + _vm._s(props.row.status) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (props.row.status === 'Halted') ? _c('div', [_c('span', {
          staticClass: "badge badge-danger"
        }, [_c('i', {
          staticClass: "fa fa-exclamation-triangle",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n                      " + _vm._s(props.row.status) + "\n                    ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (props.column.field == 'appName') ? _c('span', [_vm._v("\n                    " + _vm._s(props.row.appName) + "\n                ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'id') ? _c('span', [_vm._v("\n                  " + _vm._s(props.row.id) + "\n                ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'heliumBaseUrl') ? _c('span', [_vm._v("\n                " + _vm._s(props.row.heliumBaseUrl) + "\n                ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'journeyBaseUrl') ? _c('span', [_vm._v("\n                  " + _vm._s(props.row.journeyBaseUrl) + "\n                ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'actions') ? _c('span', {
          staticClass: "text-right"
        }, [_c('div', {
          staticClass: "btn-group",
          attrs: {
            "role": "group"
          }
        }, [_c('button', {
          staticClass: "btn btn-primary btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.selectInfo(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-info-circle"
        }), _vm._v(" Info\n                    ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-group btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.selectObjectSync(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-arrow-right-arrow-left"
        }), _vm._v(" Objects\n                    ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-success btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.selectLogs(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-history"
        }), _vm._v(" Logs\n                    ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-warning btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.selectEdit(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-edit"
        }), _vm._v(" Edit\n                    ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-danger btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.clickDelete(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-minus-circle"
        }), _vm._v(" Delete\n                    ")])])]) : _vm._e()]
      }
    }], null, false, 3761807820)
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('modal', {
    attrs: {
      "v-if": _vm.modalInfoShow,
      "show": _vm.modalInfoShow,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "large": ""
    },
    on: {
      "update:show": function($event) {
        _vm.modalInfoShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [(_vm.selection) ? _c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fa fa-rocket",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n         " + _vm._s(_vm.selection.appName) + "\n         "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.id))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [(_vm.selection) ? _c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_vm._v("\n          App ID\n          "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.id))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_vm._v("\n          Helium API URL\n          "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.heliumBaseUrl))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_vm._v("\n          Journey Environment\n          "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.journeyEnvironment))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_vm._v("\n          Journey User\n          "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.journeyUserName))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_vm._v("\n          Journey Password\n          "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.journeyPassword))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_vm._v("\n          Journey Last Sync\n          "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.formatEpoch(_vm.selection.journeyLastUpdated)))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_vm._v("\n          Helium Last Sync\n          "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.formatEpoch(_vm.selection.heliumLastUpdated)))])]), _vm._v(" "), (_vm.selection.lastPinged && _vm.selection.lastPinged != 'null') ? _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_vm._v("\n          Last Pinged\n          "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.formatEpoch(_vm.selection.lastPinged)))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_vm._v("\n          Last Helium Version Processed (change-log)\n          "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.heliumSyncStatus))]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-2 mr-sm-2 mb-sm-0"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.heliumCurl),
      expression: "heliumCurl",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Copy Command to Clipboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.heliumCurl),
      expression: "heliumCurl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "heliumCurl",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.heliumCurl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.heliumCurl = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_vm._v("\n          Last Journey Version Processed (op-log)\n          "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.journeySyncStatus))]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-2 mr-sm-2 mb-sm-0"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.journeyCurl),
      expression: "journeyCurl",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Copy Command to Clipboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.journeyCurl),
      expression: "journeyCurl"
    }],
    staticClass: "form-control sm",
    attrs: {
      "type": "text",
      "id": "journeyCurl",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.journeyCurl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.journeyCurl = $event.target.value
      }
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalInfoClose
    }
  }, [_vm._v("Close")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "v-if": _vm.modalObjectSyncShow,
      "show": _vm.modalObjectSyncShow,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "large": ""
    },
    on: {
      "update:show": function($event) {
        _vm.modalObjectSyncShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [(_vm.selection) ? _c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n         " + _vm._s(_vm.selection.appName) + "\n         "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.id))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [(_vm.showSyncFeedback) ? _c('feedback', {
    attrs: {
      "message": _vm.feedbackSyncMessage,
      "spin": _vm.showSyncSpinner,
      "success": _vm.syncSuccess
    }
  }) : _vm._e(), _vm._v(" "), _c('vue-good-table', {
    attrs: {
      "title": "Sync Objects",
      "columns": _vm.sync_columns,
      "rows": _vm.sync_rows,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'objectName',
          type: 'asc'
        }
      },
      "search-options": {
        enabled: true
      },
      "paginationOptions": {
        enabled: true
      },
      "styleClass": "vgt-table striped bordered table-hover",
      "lineNumbers": true
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'platform') ? _c('span', [_vm._v("\n                  " + _vm._s(props.row.platform) + "\n              ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'type') ? _c('span', [_vm._v("\n                  " + _vm._s(props.row.type) + "\n              ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'objectName') ? _c('span', [_vm._v("\n                  " + _vm._s(props.row.objectName) + "\n              ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'objectCount') ? _c('span', [_vm._v("\n                " + _vm._s(props.row.objectCount) + "\n              ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalObjectSyncClose
    }
  }, [_vm._v("Close")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.modalLogShow,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "title": "Sync Logs",
      "large": ""
    },
    on: {
      "update:show": function($event) {
        _vm.modalLogShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [(_vm.selection) ? _c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fa fa-rocket",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.selection.appName) + " "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.id))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [(_vm.showLogsFeedback) ? _c('feedback', {
    attrs: {
      "message": _vm.feedbackLogsMessage,
      "spin": _vm.showLogsSpinner,
      "success": _vm.logsSuccess
    }
  }) : _vm._e(), _vm._v(" "), _c('text-editor', {
    attrs: {
      "contentProp": _vm.textBlock,
      "width": _vm.textBlockWidth,
      "height": _vm.textBlockHeight,
      "readonly": _vm.textBlockReadOnly,
      "scrollToLine": _vm.scrollToLine,
      "lang": _vm.textBlockLang
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scrollToLine),
      expression: "scrollToLine"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "autoScrollToBottom"
    },
    domProps: {
      "checked": Array.isArray(_vm.scrollToLine) ? _vm._i(_vm.scrollToLine, null) > -1 : (_vm.scrollToLine)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.scrollToLine,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.scrollToLine = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.scrollToLine = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.scrollToLine = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "autoScrollToBottom"
    }
  }, [_vm._v("Scroll to bottom")])])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalLogClose
    }
  }, [_vm._v("Close")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.modalDeleteShow,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "large": ""
    },
    on: {
      "update:show": function($event) {
        _vm.modalDeleteShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fa fa-rocket",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Delete Helium Journey Integration\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('form', [_c('fieldset', [_c('legend', [_vm._v("Confirm Delete:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("App ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.heliumAppUuidForDelete),
      expression: "heliumAppUuidForDelete"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.heliumAppUuidForDelete)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.heliumAppUuidForDelete = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("App Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.heliumAppNameForDelete),
      expression: "heliumAppNameForDelete"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.heliumAppNameForDelete)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.heliumAppNameForDelete = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label text-danger"
  }, [_vm._v("Enter DELETE in capital letters")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.heliumDeleteConfirm),
      expression: "heliumDeleteConfirm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.heliumDeleteConfirm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.heliumDeleteConfirm = $event.target.value
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.deleteDisabled
    },
    on: {
      "click": _vm.modalDeleteAction
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalDeleteClose
    }
  }, [_vm._v("Close")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Sync")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "card card-inverse card-info text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("View integration details")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-info-circle card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "card card-inverse card-success text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Stream integration logs to your browser")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-history card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "card card-inverse card-warning text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Edit the configuration for an integration")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-edit card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "card card-inverse card-danger text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Disable and remove an integration")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-minus-circle card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f030af1c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Sync.vue
// module id = 598
// module chunks = 2